// removed by extract-text-webpack-plugin
module.exports = {"parts":"theme__parts___2brmw","part":"theme__part___7d5uQ","focused":"theme__focused___2H8Cd","icons":"theme__icons___2FwHn","evidenceIcon":"theme__evidenceIcon___cHzSS","reasoningIcon":"theme__reasoningIcon___3Bh1r","counterargumentIcon":"theme__counterargumentIcon___n7u--","evidence":"theme__evidence___3ucJ8","check":"theme__check___19cXC","selected":"theme__selected___1jI6p","fadeUp":"theme__fadeUp___2GJue","lateFadeUp":"theme__lateFadeUp___1TUAB","lateFadeIn":"theme__lateFadeIn___crijp"};


//////////////////
// WEBPACK FOOTER
// ./client/modules/debate/components/Strongest/Parts/theme.scss
// module id = 1312
// module chunks = 0